import { Action as ReduxAction, Dispatch } from 'redux';
import { ShapeKind, LineType, StampType } from '../../drawing/types';
import { Color } from '../../types/color';
import { LineWidth } from '../../types/lineWidth';

namespace ObjectDrawingUIAction {
  export enum ActionType {
    SELECT_TOOL = 'UI_OBJECT_DRAWING_SELECT_TOOL',
    SET_SHAPE_KIND = 'UI_OBJECT_DRAWING_SET_SHAPE_KIND',
    SET_COLOR = 'UI_OBJECT_DRAWING_SET_COLOR',
    SET_LINE_WIDTH = 'UI_OBJECT_DRAWING_SET_LINE_WIDTH',
    SET_LINE_TYPE = 'UI_OBJECT_DRAWING_SET_LINE_TYPE',
    SELECT_STAMP_TYPE = 'UI_OBJECT_DRAWING_SELECT_STAMP_TYPE',
  }

  interface SelectToolAction extends ReduxAction {
    type: typeof ActionType.SELECT_TOOL;
    selected: number;
  }

  interface SetShapeKindAction extends ReduxAction {
    type: typeof ActionType.SET_SHAPE_KIND;
    selected: number;
    shapeKind: ShapeKind;
  }

  interface SetColorAction extends ReduxAction {
    type: typeof ActionType.SET_COLOR;
    selected: number;
    color: Color;
  }

  interface SetLineWidthAction extends ReduxAction {
    type: typeof ActionType.SET_LINE_WIDTH;
    selected: number;
    lineWidth: LineWidth;
  }

  interface SetLineTypeAction extends ReduxAction {
    type: typeof ActionType.SET_LINE_TYPE;
    selected: number;
    lineType: LineType;
  }

  interface SelectStampTypeAction extends ReduxAction {
    type: typeof ActionType.SELECT_STAMP_TYPE;
    selected: number;
    selectedStampIndex: number;
    stampType: StampType;
  }

  export type Action =
    SelectToolAction
    | SetShapeKindAction
    | SetColorAction
    | SetLineWidthAction
    | SetLineTypeAction
    | SelectStampTypeAction;

  export function isDomesticAction(action: ReduxAction): action is Action {
    return Object.keys(ActionType).some(k => action.type === ActionType[k as any]);
  }

  export function selectTool(selected: number, dispatch: Dispatch<ReduxAction>) {
    dispatch({ selected, type: ActionType.SELECT_TOOL });
  }

  export function setShapeKind(
    selected: number,
    shapeKind: ShapeKind,
    dispatch: Dispatch<ReduxAction>,
  ) {
    dispatch({ selected, shapeKind, type: ActionType.SET_SHAPE_KIND });
  }

  export function setColor(
    selected: number,
    color: Color,
    dispatch: Dispatch<ReduxAction>,
  ) {
    dispatch({ selected, color, type: ActionType.SET_COLOR });
  }

  export function setLineWidth(
    selected: number,
    lineWidth: LineWidth,
    dispatch: Dispatch<ReduxAction>,
  ) {
    dispatch({ selected, lineWidth, type: ActionType.SET_LINE_WIDTH });
  }

  export function setLineType(
    selected: number,
    lineType: LineType,
    dispatch: Dispatch<ReduxAction>,
  ) {
    dispatch({ selected, lineType, type: ActionType.SET_LINE_TYPE });
  }

  export function selectStampType(
    selected: number,
    selectedStampIndex: number,
    stampType: StampType,
    dispatch: Dispatch<ReduxAction>,
  ) {
    dispatch({ selected, selectedStampIndex, stampType, type: ActionType.SELECT_STAMP_TYPE });
  }
}

export default ObjectDrawingUIAction;
